import moment from "moment-timezone";

// noinspection JSValidateTypes
export default {
  methods: {
    formatNumber(number) {
      return new Intl.NumberFormat().format(number);
    },

    formatCurrency(amount, symbol, precision) {
      const outputSymbol = symbol === undefined ? "$" : symbol;
      const outputPrecision = precision === undefined ? 2 : precision;

      return window.accounting.formatMoney(amount, outputSymbol, outputPrecision);
    },

    formatCurrencyGST(amount, gst) {
      const total = Number(window.accounting.toFixed(amount, 2));
      const gstPercentage = gst === undefined ? 10 : gst;

      return this.formatCurrency(total * (gstPercentage / (gstPercentage + 100)));
    },

    formatCurrencyWithoutGST(amount, gst) {
      const total = Number(window.accounting.toFixed(amount, 2));
      const gstPercentage = gst === undefined ? 10 : gst;

      return this.formatCurrency(total / (1 + gstPercentage / 100));
    },

    formatDate(date, format) {
      if (!date) {
        return "";
      }

      const humanFormat = "ddd DD MMM YYYY@h:mma";
      // noinspection JSValidateTypes
      const theDate = typeof date === "string" || date instanceof String ? moment(date) : date;
      const formatTo = format === undefined ? humanFormat : format;

      return theDate.format(formatTo);
    },

    formatLocalDate(date, format) {
      if (!date) {
        return "";
      }

      const humanFormat = "ddd DD MMM YYYY@hh:mma";
      // noinspection JSUnresolvedFunction
      const theDate =
        typeof date === "string" || date instanceof String ? moment.tz(date, "UTC") : date;
      const formatTo = format === undefined ? humanFormat : format;

      return theDate.tz("Australia/Melbourne").format(formatTo);
    },

    formatLocalDateToUTC(date, format) {
      if (!date) {
        return "";
      }

      const defaultUTCFormat = "YYYY-MM-DD HH:mm:ss";
      // noinspection JSUnresolvedFunction
      const theDate =
        typeof date === "string" || date instanceof String
          ? moment.tz(date, "Australia/Melbourne")
          : date;
      const formatTo = format === undefined ? defaultUTCFormat : format;

      return theDate.tz("UTC").format(formatTo);
    },
  },
};
